import css from 'styled-jsx/css';

const styles = css.global`.c2c-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.c2c-stack .c2c-stack-title {
  margin: 0;
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-bottom: 24px;
}

.c2c-stack .c2c-stack-subtitle {
  margin: 0;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 32px;
}

.c2c-stack .c2c-stack-btn {
  color: #fff;
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  margin-bottom: 40px;
  display: block;
}

.c2c-stack .c2c-stack-content {
  margin-top: 32px;
}

.c2c-stack .c2c-stack-content img {
  margin-bottom: 24px;
}

@media (min-width: 992px) {
  .c2c-stack {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
    position: relative;
    min-height: 507px;
  }

  .c2c-stack .c2c-stack-title {
    font-size: 72px;
    margin-bottom: 40px;
  }

  .c2c-stack .c2c-stack-subtitle {
    margin-bottom: 24px;
  }

  .c2c-stack .c2c-stack-content {
    width: 100%;
    max-width: 453px;
  }

  .c2c-stack .c2c-video-container {
    flex: 1;
    display: flex;
    width: 100%;
    position: absolute;
    left: calc(453px + 46px);
    top: 0;
    max-width: 726px;
    height: 507px;
  }

  /* #c2c-video .c2c-stack .c2c-video-container {
    left: calc(215px + 46px);
  } */

  .c2c-stack .ctn-home-24 {
    overflow: visible;
  }
}
`;

export default styles;